import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    filter: {
        width: 282
    },
    header: {
        fontWeight: 700,
        marginBottom: 24
    },
    fields: {
        background: '#FAFAFA',
        borderRadius: 18
    },
    field: {
        '& .MuiInput-root::before, .MuiInput-root::after, .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: 'none'
        },
        '& .MuiSelect-select': {
            paddingLeft: 8
        },
        '& .MuiSelect-select:focus': {
            borderRadius: 8
        },
        borderBottom: '2px solid #fff',
        padding: '0 20px 12px'
    },
    switch: {
        padding: '16px 16px 2px 0',
        marginLeft: 0,
        color: '#979797',
        '& .MuiFormControlLabel-label': {
            flex: 1,
            color: '#979797'
        }
    },
    select: {
        '& .MuiSelect-root': {
            display: 'flex',
            flexDirection: 'row'
        },
        '& .MuiSelect-root .MuiTypography-root': {
            fontSize: 14
        }
    },
    label: {
        color: '#979797',
        fontSize: 14
    },
    avatar: {
        width: 32,
        height: 32
    },
    capitalize: {
        textTransform: 'capitalize'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    button: {
        padding: '14px 12px',
        borderRadius: 12,
        marginTop: 20,
        minWidth: 130,
        borderColor: '#EEEEEE',
        color: '#979797',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        height: 44
    },
    resultsButton: {
        border: '0 !important',
        background: '#232323',
        color: '#fff',
        '&:disabled': {
            color: '#fff',
            background: '#232323',
            opacity: 0.7
        },
        '&:hover': {
            background: '#232323'
        },
        '&:focus': {
            background: '#232323'
        },
        '&:active': {
            background: '#232323'
        }
    },
    cancelButton: {
        border: '0 !important',
        background: '#F8F8F8',
        color: '#232323',
        '&:disabled': {
            color: '#232323',
            background: '#F8F8F8',
            opacity: 0.7
        },
        '&:hover': {
            background: '#F8F8F8'
        },
        '&:focus': {
            background: '#F8F8F8'
        },
        '&:active': {
            background: '##F8F8F8'
        }
    },
    suggestMenuItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    }
});
